import {useContext} from 'react'
import {OrderDataContext} from '../../../context/OrderDataContext'
import {ReservationContext} from '../../../context/ReservationContext'
import config from '../../../config'
import { TranslationContext } from '../../../context/TranslationContext'

function Price() {
    const {order} = useContext(OrderDataContext)
    const {reservation} = useContext(ReservationContext)
    const {translations} = useContext(TranslationContext)

    const amountToPay = () => {
        let includedPrice = reservation.guests * config.price_per_guest;
        if (includedPrice < config.minimum_price) {
            includedPrice = config.minimum_price;
        }
        if (order.price <= includedPrice) {
            return 0
        }

        return (order.price - includedPrice).toFixed(2)
    }

    return <>
        <p>
            {translations.total_order_amount} {order.price.toFixed(2)}€
            {' '+translations.total_pay} <strong>{amountToPay()}€</strong>
        </p>
    </>
}

export default Price
